import React from 'react';
import LoadingSpinner from '../../../shared/atoms/LoadingSpinner';

interface RouteLoadingSpinnerProps {
  size?: number;
}

const RouteLoadingSpinner: React.FC<RouteLoadingSpinnerProps> = ({ 
  size = 60
}) => {
  return <LoadingSpinner size={size} />;
};

export default RouteLoadingSpinner;